<template>
  <div class="pw-input-parent">
    <textarea
      class="pw-textarea"
      :value="computedValue"
      @input="onInput"
      :name="name"
      :disabled="disabled"
      :readonly="readonly"
      :class="textTransform"
      @blur="onBlur"
      :placeholder="placeholder"
      v-on="$listeners"
      :maxlength="maxlength"
    />
    <span class="clearable" v-if="clearable && computedValue"
      ><i @click="clearValue" class="mdi mdi-window-close"></i
    ></span>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  mounted() {
    if (this.autofocus) {
      setTimeout(() => this.$el.getElementsByTagName('textarea')[0].focus(), 20);
    }
    this.changeName();
    this.changeRequired();
  },
  props: {
    value: {
      type: [Number, String],
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: [Boolean, String],
      default: false,
    },
    textTransform: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    name: String,
    placeholder: String,
    maxlength: Number,
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newValue: this.value,
      disabled: false,
    };
  },
  methods: {
    onBlur(event) {
      const { value } = event.target;
      switch (this.textTransform) {
        case 'uppercase':
          this.computedValue = value.toUpperCase();
          break;
        case 'capitalize':
          this.computedValue = this.toCapitalize(value);
          break;
        case 'lowercase':
          this.computedValue = value.toLowerCase();
          break;
        default:
          break;
      }
    },
    onInput(event) {
      this.$nextTick(() => {
        this.computedValue = event.target.value;
      });
    },
    toCapitalize(value) {
      return value
        .split(' ')
        .map((word) => {
          if (word === word.toUpperCase()) {
            return word;
          }
          return word.substring(0, 1).toUpperCase() + word.substring(1, word.length);
        })
        .join(' ');
    },
    toLowerCase(value) {
      return value
        .split(' ')
        .map((word) => {
          if (word === word.toLowerCase()) {
            return word;
          }
          return word.substring(0, 1).toLowerCase() + word.substring(1, word.length);
        })
        .join(' ');
    },
    changeName() {
      if (this.$parent.changeName) {
        this.$parent.changeName(this.name);
      }
    },
    changeRequired() {
      if (this.$parent.changeRequired) {
        this.$parent.changeRequired(this.required);
      }
    },
    clearValue() {
      this.computedValue = '';
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.newValue;
      },
      set(value) {
        this.$emit('input', value);
        this.newValue = value;
      },
    },
  },
  watch: {
    value(value) {
      this.newValue = value;
    },
    name() {
      this.changeName();
    },
    required() {
      this.changeRequired();
    },
    vscope() {
      // this.$el.setAttribute("data-vv-scope", this.vscope);
    },
  },
};
</script>

<style lang="scss">
.pw-textarea {
  box-sizing: border-box;
  height: 64px;
  width: 100%;
  resize: none;
  border: 1px solid #bdc6cc;
  border-radius: 3px;
  padding-left: 8px;
  font-size: 16px;
  color: #333;
  font-family: 'Nunito Sans', sans-serif;
  outline: none;
  &:focus {
    border-color: #4571d8;
  }
  &::placeholder {
    color: #bdc6cc;
    text-transform: none;
  }
  &:disabled {
    background-color: #e9ecef !important;
  }
  &[disabled] {
    background-color: #e9ecef !important;
  }
  &:read-only {
    background-color: #e9ecef;
    cursor: not-allowed;
    &:focus {
      border-color: #bdc6cc;
    }
  }
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.lowercase {
  text-transform: lowercase;
}

.pw-textarea-parent {
  display: block;
  position: relative;
  width: 100%;
  .clearable {
    position: absolute;
    top: calc(100% / 6);
    right: 5px;
    color: #cccccc;
  }
}
</style>
